(function () {
  function initCountdowns(root) {
    const scope = root || document;
    const timers = scope.querySelectorAll('.countdown-timer:not([data-wf-countdown-init])');

    timers.forEach(function (timer) {
      timer.setAttribute('data-wf-countdown-init', 'true');

      const productInfo = timer.closest('product-info[data-product-id]') || document.querySelector('product-info[data-product-id]');
      const productId = productInfo ? productInfo.getAttribute('data-product-id') : 'default';
      const storageKey = 'product_timer_' + productId;
      const countdownHours = 24;

      let endTime = localStorage.getItem(storageKey);

      if (!endTime) {
        endTime = String(Date.now() + countdownHours * 60 * 60 * 1000);
        localStorage.setItem(storageKey, endTime);
      }

      function updateCountdown() {
        const distance = Number(endTime) - Date.now();

        if (distance <= 0) {
          timer.textContent = '00:00:00';
          return;
        }

        const hours = Math.floor(distance / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        timer.textContent =
          String(hours).padStart(2, '0') +
          ':' +
          String(minutes).padStart(2, '0') +
          ':' +
          String(seconds).padStart(2, '0');
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCountdowns(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCountdowns(event.target);
  });

  document.addEventListener('click', function (event) {
    const zoomButton = event.target.closest('[data-wf-product-zoom]');
    if (!zoomButton) return;

    const mediaWrapper = zoomButton.closest('.product__media-wrapper');
    if (!mediaWrapper) return;

    const activeMedia =
      mediaWrapper.querySelector('.product__media-item.is-active') ||
      mediaWrapper.querySelector('.product__media-item');

    const mediaToggle = activeMedia
      ? activeMedia.querySelector('.product__media-toggle')
      : mediaWrapper.querySelector('.product__media-toggle');

    if (mediaToggle) {
      mediaToggle.click();
    }
  });
})();